import {Component, inject, OnInit, ViewChild} from '@angular/core';
import { DependenciaDto, IGetUsuarioBasico, VwSecDependencia } from '../../../shared/interfaces/database/seguridad';
import { SecDependenciaService } from '../../../services/database/secDependencia.service';
import { ConfirmationService, MessageService } from 'primeng/api';
import { AccessRole, ButtonColumnType, CustomTableComponent, CustomTitle, DataColumnType, FormGroupErrorMessageComponent, ICustomTable, IHeader, LoadingPanelService, LocalService, noWhitespaceValidator, Page, Utils } from 'lib-base';
import { CommonModule } from '@angular/common';
import { TableModule } from 'primeng/table';
import { ButtonModule } from 'primeng/button';
import { FormBuilder, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import { ConfirmPopupModule } from 'primeng/confirmpopup';
import { DialogModule } from 'primeng/dialog';
import { InputTextModule } from 'primeng/inputtext';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { firstValueFrom, forkJoin } from 'rxjs';
import { AdminDependenciasHistoricoComponent } from './admin-dependencias-historico/admin-dependencias-historico.component';
import { SecUsuarioService } from '../../../services/database/secUsuario.service';
import { DropdownModule } from 'primeng/dropdown';
import {CustomTitleDirective} from "../../../shared/clases/custom-title.directive";

@Component({
  selector: 'app-admin-dependencias',
  standalone: true,
  imports: [
    CommonModule, ReactiveFormsModule, TranslateModule, CustomTableComponent, AdminDependenciasHistoricoComponent,
    TableModule, ButtonModule, ConfirmPopupModule, DialogModule, InputTextModule, DropdownModule,
    FormGroupErrorMessageComponent, CustomTitle
  ],
  providers: [ConfirmationService],
  templateUrl: './admin-dependencias.component.html',
  styleUrls: ['./admin-dependencias.component.scss', '../../../../assets/styles/style.mantenimiento.scss']
})
export class AdminDependenciasComponent implements OnInit {

  formTitle: string = "Nuevo";
  displayModal = false;
  dependenciaForm !: FormGroup;
  private _editDependencia !: VwSecDependencia | undefined;
  usuarios: IGetUsuarioBasico[] = [];

  trans: any = {};
  customTable !: ICustomTable;
  @ViewChild(CustomTableComponent) customTableComponent !: CustomTableComponent;
  @ViewChild(AdminDependenciasHistoricoComponent) historico !: AdminDependenciasHistoricoComponent;
  role = AccessRole;
  private originalValues: any;
  private titleService:CustomTitleDirective = inject(CustomTitleDirective);

  constructor(private _sd: SecDependenciaService, private _lps: LoadingPanelService, private _t: TranslateService,
    private _ms: MessageService, private _fb: FormBuilder, private _cs: ConfirmationService, public ls: LocalService,
    private _us: SecUsuarioService) {
    this.configureNewDependenciaForm();
  }

  get isNewForm(): boolean {
    return this._editDependencia === undefined;
  }

  ngOnInit(): void {
    this.titleService.changeTitle('common.dependencia');
    this.translate();
    this.getDependencias();
    this.getUsuariosBasico();
  }

  private async translate(): Promise<void> {
    this.trans = await firstValueFrom(forkJoin({
      title: this._t.get('common.dependencia'),
      requiereRolSeguridad: this._t.get('msg.requiere-rol-seguridad'),
      descripcion: this._t.get('common.descripcion'),
      liderDependencia: this._t.get('common.liderDependencia'),
      exito: this._t.get('common.exito'),
      advertencia: this._t.get('common.advertencia'),
      noCambiosFormulario: this._t.get('msg.noCambiosFormulario'),
      completeCamposRequeridos: this._t.get('msg.completeCamposRequeridos'),
      nuevaDependencia: this._t.get('common.nuevaDependencia'),
      editarDependencia: this._t.get('common.editarDependencia'),
    }));
    this.customTable = {
      header: {
        title: this.trans.title,
        class:"title font-roboto-condensed font-18 title-blue text-uppercase font-normal mb-0",
      } as IHeader,
      columns: [
        {
          field: 'descripcion',
          header: this.trans.descripcion,
          sort: true,
          class: 'font-13',
          columnmHeader: {
            class: 'text-left color-blue-2 font-13 font-bold',
            style: ''
          },
          columnFilter: true,
          dataType: DataColumnType.TEXT
        },
        {
          field: 'liderNombreCompleto',
          header: this.trans.liderDependencia,
          sort: true,
          class: 'font-13',
          columnmHeader: {
            class: 'text-left color-blue-2 font-13 font-bold',
            style: ''
          },
          columnFilter: true,
          dataType: DataColumnType.TEXT
        },
        {
          field: 'abrir',
          header: '',
          icon: 'pi pi-history',
          class: 'button-edit p-button-outlined pt-2 pb-2 pr-0',
          width: '0rem',
          severity: 'info',
          buttonType: ButtonColumnType.CUSTOM,
          onClick: (event: Event, data: VwSecDependencia) => this.abrirHistorial(data),
        },
        {
          field: 'edit',
          header: '',
          width: '0rem',
          class: 'pt-2 pb-2 pl-1 pr-1',
          buttonType: ButtonColumnType.EDIT,
          disabled: !this.ls.hasRole(this.role.ADMIN_SEC),
          tooltip: {
            message: this.trans.requiereRolSeguridad
          },
          onClick: (event: Event, data: VwSecDependencia) => this.openEditModal(data),
          headerBtn: {
            icon: 'pi pi-history',
            class: 'pt-2 pb-2 pl-0 pr-0',
            severity: 'info',
            onClick: (event: Event) => this.abrirHistorialEliminado(),
          }
        },
        {
          field: 'delete',
          header: '',
          width: '0rem',
          class: 'pt-2 pb-2 pl-0',
          buttonType: ButtonColumnType.DELETE,
          disabled: !this.ls.hasRole(this.role.ADMIN_SEC),
          tooltip: {
            message: this.trans.requiereRolSeguridad
          },
          onClick: (event: Event, data: VwSecDependencia) => this.deleteConfirmation(event, data),
          headerBtn: {
            icon: 'pi pi-plus',
            class: 'pt-2 pb-2 pl-0 pr-0',
            onClick: (event: Event) => this.openNewModal(),
            disabled: !this.ls.hasRole(this.role.ADMIN_SEC),
          },
          headerTooltip:{
            message: this.trans.requiereRolSeguridad,
            disabled: this.ls.hasRole(this.role.ADMIN_SEC)
          }
        }
      ],
      settings: {
        table: {
          rows: 10,
        }
      }
    } as ICustomTable;
  }

  configureNewDependenciaForm() {
    this.dependenciaForm = this._fb.group({
      descripcion: [null, [Validators.required, noWhitespaceValidator, Validators.maxLength(255)]],
      liderDependenciaId: [null, [Validators.required]],
    });
  }

  openNewModal() {
    this.formTitle = this.trans.nuevaDependencia;
    this._editDependencia = undefined;
    this.resetForm();
    this.displayModal = true;
  }

  openEditModal(dependencia: VwSecDependencia) {
    this.resetForm();
    this.formTitle = this.trans.editarDependencia;
    this._editDependencia = dependencia;
    this.dependenciaForm.get('descripcion')?.setValue(dependencia.descripcion);
    this.dependenciaForm.get('liderDependenciaId')?.setValue(dependencia.liderDependenciaId);
    this.displayModal = true;
    this.originalValues = { ...this.dependenciaForm.value };
  }

  deleteConfirmation(event: Event, data: VwSecDependencia) {
    this._cs.confirm({
      target: event.target as EventTarget,
      message: 'Estas seguro de que quieres eliminar la dependencia?',
      icon: 'pi pi-exclamation-triangle',
      accept: () => {
        this.deleteDependencia(data.id);
      },
      reject: () => {

      }
    });
  }

  resetForm() {
    this.dependenciaForm.reset();
  }

  onSubmit() {
    if (this.dependenciaForm.pristine) {
      this._ms.add({ severity: 'warn', summary: this.trans.advertencia, detail: this.trans.noCambiosFormulario });
      return;
    }

    if (this.dependenciaForm.invalid) {
      Utils.markAllFormControlsAsTouched(this.dependenciaForm);
      this._ms.add({ severity: 'warn', summary: this.trans.advertencia, detail: this.trans.completeCamposRequeridos });
      return;
    }

    const newValues = {
      descripcion: this.dependenciaForm.get('descripcion')?.value,
      liderDependenciaId: this.dependenciaForm.get('liderDependenciaId')?.value
    } as DependenciaDto;

    if (this.isNewForm) {
      this.createDependencia(newValues);
    } else if (!Utils.isDeepEqual(this.originalValues, newValues)) {
      this.updateDependencia(newValues);
    } else {
      this._ms.add({ severity: 'warn', summary: this.trans.advertencia, detail: this.trans.noCambiosFormulario });
    }
  }

    abrirHistorial(data: VwSecDependencia): void {
      this.historico.show(data.id);
    }

    abrirHistorialEliminado(): void {
      this.historico.showEliminado();
    }

  //#region API Calls
  getUsuariosBasico() {
    this._us.getUsuariosBasico().subscribe({
      next: (usuarios: IGetUsuarioBasico[]) => {
        this.usuarios = usuarios;
      }
    });
  }

  getDependencias() {
    this._sd.getDependencias().subscribe({
      next: (page: Page<VwSecDependencia>) => {
        this.customTableComponent.data = page.content;
      }
    });
  }

  createDependencia(newDependencia: DependenciaDto) {
    this._lps.show(true);
    this._sd.createDependencia(newDependencia).subscribe({
      next: (response: string) => {
        this._lps.hide();
        this._ms.add({ severity: 'success', summary: 'Dependencia Creada', detail: response });
        this.displayModal = false;
        this.getDependencias();
      }
    });
  }

  updateDependencia(newDependencia: DependenciaDto) {
    if (!this._editDependencia) return;
    this._lps.show(true);
    this._sd.updateDependencia(this._editDependencia.id, newDependencia).subscribe({
      next: (response: string) => {
        this._lps.hide();
        this._ms.add({ severity: 'success', summary: 'Dependencia Actualizada', detail: response });
        this.displayModal = false;
        this.getDependencias();
      }
    });
  }

  deleteDependencia(dependenciaId: number) {
    this._lps.show(true);
    this._sd.deleteDependencia(dependenciaId).subscribe({
      next: (response: string) => {
        this._lps.hide();
        this._ms.add({ severity: 'success', summary: 'Dependencia Eliminada', detail: response });
        this.getDependencias();
      }
    });
  }
  //#endregion
}
